import t_12_2480 from './KZ.Т.12.2480.svg'
import t_12_2480_b from './KZ.Т.12.2480 black.svg'

export default [
  t_12_2480,
  t_12_2480_b
]
